import React from "react";
import { Spinner } from "react-bootstrap";
import { useUserQuery } from "../../../graphql/menu.hooks";

export default function UserData() {
  const { data, loading } = useUserQuery();
  const user = data?.user.email;
  const firstLetterFirstName =
    data?.user?.firstName?.charAt(0) || user?.charAt(0);
  const firstLetterLastName =
    data?.user?.lastName?.charAt(0) || user?.charAt(1);

  if (loading) {
    return <Spinner animation="border" role="status"></Spinner>;
  }

  return (
    <>
      <div className="mb-4 mb-md-5">
        <div className="d-flex">
          <div className="me-4 px-3 avatar fs-6 text-white d-flex justify-content-center align-items-center">
            {firstLetterFirstName}
            {firstLetterLastName}
          </div>
          <div className="overflow-hidden">
            <p className="text-dark f-18 fw-bold mb-0 lh-sm ">
              {data?.user?.firstName || data?.user?.lastName
                ? `${data?.user?.firstName || ""} ${data?.user?.lastName || ""}`.trim()
                : user}
            </p>
            <p className="fs-7 text-gray mb-0">{user}</p>
          </div>
        </div>
      </div>
    </>
  );
}
